
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M86.8 29.8L64 0 41.2 29.8c-17.2 22.5-24 32.6-24 47.7 0 12.8 3.3 19 15.3 27.7L64 128l31.5-22.8c12-8.7 15.3-14.9 15.3-27.7 0-15.1-6.8-25.2-24-47.7zm-29.8 74l-.2 6.2c0 .8-.5.9-1 .5C47.6 104.6 38 97.6 38 97.6c-10-7.2-10.6-15-10.6-20.3 0-3.6.5-7.5 2.2-11.5.1-.3.3-.8.6-.8.2 0 .3.1.4.3 3.5 5.1 9.1 13.4 14.7 20.2 10.8 13 11.9 11.9 11.7 18.3zm7-11.7c-.1 0-.2-.1-.3-.1L41.6 65.8c-2.5-3-3.9-6.3-3.9-9.6 0-2.2.8-4.5 2.4-6.6l23.6-32.4c.1-.1.2-.2.3-.2.1 0 .2.1.3.2l23.6 32.4c1.5 2.1 2.4 4.4 2.4 6.6 0 3.3-1.3 6.6-3.9 9.6L64.3 92c-.1.1-.2.1-.3.1zm26 5.5s-9.7 7-17.8 12.9c-.5.4-.9.3-1-.5l-.2-6.2c-.2-6.4.9-5.3 11.7-18.3 5.6-6.8 11.2-15 14.7-20.2.1-.2.3-.3.4-.3.2 0 .5.5.6.8 1.6 4 2.2 7.9 2.2 11.5 0 5.3-.6 13.1-10.6 20.3z"}})])
          )
        }
      }
    